@let item = proposal();
<div
  class="row"
  role="listitem"
  [class.row--expanded]="expanded()"
  data-testid="dictionary-review-row">
  <div class="row__line">
    <div
      class="row__main"
      role="button"
      tabindex="0"
      [attr.aria-expanded]="expanded()"
      [attr.aria-label]="
        'Ver detalhes da mudança em ' + (item.standardAccountLabel ?? 'conta padrão')
      "
      (click)="toggleRequested.emit()"
      (keydown)="onMainKeydown($event)">
      <i
        class="pi row__chevron"
        [class.pi-chevron-right]="!expanded()"
        [class.pi-chevron-down]="expanded()"
        aria-hidden="true"></i>
      <div class="row__account" [attr.title]="path() ?? item.standardAccountLabel ?? ''">
        <span class="row__account-label">{{ item.standardAccountLabel ?? 'Conta padrão' }}</span>
        <small class="row__account-path">
          {{ statementLabel() }}
          @if (path(); as fullPath) {
            · {{ fullPath }}
          }
        </small>
      </div>
      <span class="tag row__kind" [attr.data-kind]="item.kind" data-testid="dictionary-review-kind">
        {{ kindLabel() }}
      </span>
      <p class="row__text" [class.row__text--clamped]="!expanded()" [attr.title]="text()">
        {{ text() }}
      </p>
      @if (item.entryHasHouseDecisions) {
        <i
          class="pi pi-exclamation-triangle row__warning"
          role="img"
          aria-label="O verbete tem decisão da casa registrada"
          pTooltip="Este verbete tem decisão da casa registrada. Confira se o texto novo não contradiz a decisão."
          tooltipPosition="top"
          data-testid="dictionary-review-house-warning"></i>
      }
    </div>

    @if (canManage()) {
      <div class="row__actions">
        <app-button
          [icon]="'pi pi-check'"
          [pureIcon]="true"
          [theme]="'white'"
          [type]="'button'"
          [ariaLabel]="'Manter esta mudança'"
          pTooltip="Manter: a mudança continua no dicionário e sai desta lista"
          tooltipPosition="top"
          [disabled]="locked()"
          [isLoading]="busy()"
          [loadingText]="''"
          data-testid="dictionary-review-keep"
          (sendButtonClick)="keepRequested.emit(item)" />
        <app-button
          [icon]="'pi pi-undo'"
          [pureIcon]="true"
          [theme]="'white'"
          [type]="'button'"
          [ariaLabel]="'Desfazer esta mudança'"
          pTooltip="Desfazer: tira o texto do dicionário criando uma versão nova"
          tooltipPosition="top"
          [disabled]="locked()"
          data-testid="dictionary-review-revert"
          (sendButtonClick)="revertRequested.emit(item)" />
      </div>
    }
  </div>

  @if (expanded()) {
    <div class="row__details" data-testid="dictionary-review-details">
      <div class="row__detail-col">
        @if (item.rationale) {
          <span class="row__label">Por que o revisor propôs</span>
          <p class="row__detail-text">{{ item.rationale }}</p>
        }
        @if (item.clientAccountLabel) {
          <span class="row__label">Linha que motivou</span>
          <p class="row__detail-text">{{ item.clientAccountLabel }}</p>
        }
        @if (item.occurrences > 1) {
          <p class="row__muted">O revisor propôs a mesma mudança {{ item.occurrences }} vezes.</p>
        }
        @if (item.entryHasHouseDecisions) {
          <p class="row__house" role="note">
            <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
            Este verbete tem decisão da casa registrada. Se o texto novo contradiz a decisão, use
            Desfazer.
          </p>
        }
      </div>
      <div class="row__detail-col row__detail-col--current">
        <span class="row__label">{{ sectionLabel() }} (versão em uso)</span>
        @if (!item.currentEntry) {
          <p class="row__muted">
            O verbete atual não veio com a proposta; ele aparece em Verbetes.
          </p>
        } @else if (currentItems().length === 0) {
          <p class="row__muted">Esta parte do verbete está vazia.</p>
        } @else {
          <ul class="row__current">
            @for (current of currentItems(); track $index) {
              <li [class.row__current--new]="current.isProposed">{{ current.text }}</li>
            }
          </ul>
        }
      </div>
    </div>
  }
</div>
